import BannerWithUps from "./BannerWithUps";

export default BannerWithUps;
